import ar from "./ar";
import en from "./en";
import es from "./es";
import pt from "./pt";
import ru from "./ru";
import ur from "./ur";
import uz from "./uz";
import zh from "./zh";

export default { ar, en, ru, ur, uz, es, pt, zh };
